import React, { useEffect, useState } from 'react';


import Header from "../../components/Header";
import Footer from "../../components/Footer";
import DataTableProducts from './DatatableProducts';

function AdminProducts() {

return ( <>
        <Header />
        <section className="sectionPageContent">
            <h1>
                ADMIN PRODUCTS
            </h1>    
        </section>        
        <div>
            <DataTableProducts />
        </div>
        <Footer />
        </>    );
}

export default AdminProducts;